import {IIncident} from "../../../core/interfaces/incident";
import CustomTextAreaInput from "../../../components/FormComponents/CustomTextAreaInput";
import FormProvider from "./FormProvider/FormProvider";

export function CauseOfEventForm(props: { editMode: boolean, newIncident: IIncident, onChange: (e: any) => void }) {
    return <FormProvider controlId={'formCauseOfEvent'} title={'Orsak'} colAs={props.editMode ? 'large' : 'sm'}>
        <CustomTextAreaInput
            isEditMode={props.editMode}
            rows={5}
            testId={'formCauseOfEvent'}
            name={"causeOfEvent"}
            value={props.newIncident.causeOfEvent ?? ''}
            onChange={props.onChange}
            required
        />
    </FormProvider>
}